import { ContentsCollapsibleWeb } from '@components/enrollments/courses/course_contents/ContentsCollapsibleWeb'
import ContentsModal from '@components/enrollments/courses/course_contents/ContentsModal'
import { CourseContentConsumption } from '@components/enrollments/courses/course_contents/CourseContentConsumption'
import { CourseContentsProvider } from '@contexts/CourseContentsContext'
import { CourseProvider } from '@contexts/CourseContext'
import { EnrollmentProvider } from '@contexts/EnrollmentContext'
import { ModulesProvider } from '@contexts/ModulesContext'
import { useMediaSize } from '@hooks/useMediaSize'
import { usePushValueMoment } from '@hooks/usePushValueMoment'
import { useUpNavigation } from '@hooks/useUpNavigation'
import { AppLayout } from '@layouts/AppLayout'
import { useActivityStore } from '@stores/useActivityStore'
import { isWeb, View } from 'tamagui'

/**
 * Tela de consumo da aula, compartilhada entre a rota do aluno
 * (/enrollments/:id/...) e a do preview do produtor (/admin_view/...). O que
 * diferencia as duas é a ausência de enrollmentId na URL, que o
 * EnrollmentProvider detecta.
 */
export function CourseContentsScreen() {
  const displayModal = !isWeb

  const mediaSize = useMediaSize()
  const isMobile = ['xs', 'sm'].includes(mediaSize)

  const { finishRetryByNavigation } = useActivityStore()
  const goUp = useUpNavigation()
  usePushValueMoment(true)

  return (
    <CourseProvider>
      <EnrollmentProvider>
        <CourseContentsProvider>
          <ModulesProvider>
            <AppLayout
              backRoute={{
                label: 'Voltar',
                back: () => {
                  finishRetryByNavigation()
                  goUp()
                },
              }}
              hasFooter={isWeb}
              hasPaddingBottom={false}
              hasBackButton={isMobile}
              // A tela de consumo já tem a barra fixa da aula no rodapé; o
              // botão de voltar ao topo colidia com ela.
              hasScrollTopButton={false}
            >
              <>
                <View flex={1} position="relative">
                  <CourseContentConsumption />
                  {displayModal && <ContentsModal />}
                </View>
                {!displayModal && isMobile && (
                  <ContentsCollapsibleWeb type="bottomFixed" />
                )}
              </>
            </AppLayout>
          </ModulesProvider>
        </CourseContentsProvider>
      </EnrollmentProvider>
    </CourseProvider>
  )
}
